import { Flex, Typography } from "antd"

import MonthStatus from "../../../VAMP/components/MonitoringProgram/MonthStatus/MonthStatus"
import { getStatusIcon } from "../../../VAMP/utils/getMonitoringMonthIcon"
import { STATUS_CONDITIONS, STATUS_CONDITIONS_PANEL_TITLE, STATUS_LABELS } from "../monitoringCopy"

import "./StatusConditionsPanel.less"

const { Text } = Typography

const StatusConditionsPanel = ({ id, isOpen }) => {
  return (
    <div className="status-conditions-panel" id={id} hidden={!isOpen}>
      <Text type="secondary" className="status-conditions-panel__title">
        {STATUS_CONDITIONS_PANEL_TITLE}
      </Text>
      <div className="status-conditions-panel__grid">
        {STATUS_CONDITIONS.map(({ status, condition }) => {
          const { icon, variant } = getStatusIcon(status)

          return (
            <Flex key={status} gap={8} align="flex-start" className="status-conditions-panel__row">
              <MonthStatus icon={icon} variant={variant} />
              <Text type="secondary">
                <Text strong className="status-conditions-panel__name">
                  {STATUS_LABELS[status]}
                </Text>{" "}
                {condition}
              </Text>
            </Flex>
          )
        })}
      </div>
    </div>
  )
}

export default StatusConditionsPanel
